package br.com.texeratx.boardgametimeapp.ui.screens.forgot_password

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.text.ClickableText
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.core.i18n.LocalStrings
import br.com.texeratx.boardgametimeapp.ui.components.AuthCardLayout

@Composable
fun ForgotPasswordUI(
    state: ForgotPasswordUiState,
    onEmailChange: (String) -> Unit,
    onSubmitClick: () -> Unit,
    onGoToResetPassword: () -> Unit,
    onBack: () -> Unit
) {
    val S = LocalStrings.current
    val canSubmit = state.email.isNotBlank() && !state.isLoading

    AuthCardLayout {
        Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {

            Text(S.forgotPasswordTitle, style = MaterialTheme.typography.headlineSmall)

            if (state.isSuccess) {
                Text(
                    S.forgotPasswordSuccess,
                    style = MaterialTheme.typography.bodyMedium
                )

                Button(
                    onClick = onGoToResetPassword,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Text(S.enterCode)
                }
            } else {
                Text(
                    S.forgotPasswordInstructions,
                    style = MaterialTheme.typography.bodyMedium
                )

                OutlinedTextField(
                    value = state.email,
                    onValueChange = onEmailChange,
                    label = { Text(S.labelEmail) },
                    modifier = Modifier.fillMaxWidth(),
                    singleLine = true
                )

                Button(
                    onClick = onSubmitClick,
                    enabled = canSubmit,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    if (state.isLoading) {
                        CircularProgressIndicator(
                            color = MaterialTheme.colorScheme.onPrimary,
                            modifier = Modifier.size(20.dp)
                        )
                        Spacer(Modifier.width(12.dp))
                        Text(S.sending)
                    } else {
                        Text(S.sendInstructions)
                    }
                }

                state.error?.let {
                    Text(it, color = MaterialTheme.colorScheme.error)
                }
            }

            ClickableText(
                text = AnnotatedString(S.backToLogin),
                style = MaterialTheme.typography.bodyMedium.copy(color = MaterialTheme.colorScheme.primary),
                onClick = { onBack() }
            )
        }
    }
}
